var bramidan = bramidan || {};
( function () {
    'use strict';
    jQuery( function () {
        bramidan.init();
        e4.lazyload.init();
    } );
    jQuery( window ).on( 'load resize', function () {
        //Set height of carousel
        if ( jQuery( '#js-e-product-image-carousel' ).length ) {
            var height = jQuery( '#js-e-product-image-carousel' ).outerHeight();
            jQuery( '#js-e-product-image-carousel' ).find( '.carousel-indicators' ).height( height );
        }

        e4.nav.global.show();

    } );
    bramidan.init = function () {
        bramidan.utils.isEmpty();
        bramidan.dealersearch.init();
        bramidan.carousel.init();
        bramidan.modal.init();
        bramidan.countrydetector.init();
        bramidan.ecom.details.init();
        bramidan.hacks.init();
        bramidan.video.init();
    };
    bramidan.utils = {
        isMobile: function () {
            var check = false;
            ( function ( a ) {
                if ( /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i.test( a ) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test( a.substr( 0, 4 ) ) ) check = true;
            } )( navigator.userAgent || navigator.vendor || window.opera );
            return check;
        },
        isEmpty: function () {
            jQuery( '.p-txt-container' ).each( function () {
                if ( jQuery.trim( jQuery( this ).text() ) === '' ) {
                    jQuery( this ).css( 'margin', '0' );
                }
            } );
        }
    };
    bramidan.hacks = {
        init: function () {
            bramidan.hacks.overrideModuleHeadline();
        },
        overrideModuleHeadline: function () {
            //Hack to replace headline of forms
            var overrideHeadline = jQuery.trim( jQuery( '.js-module-headline-override-source' ).data( 'module-headline-override' ) );
            if ( overrideHeadline !== '' ) {
                jQuery( '.js-module-headline-override-target' ).text( overrideHeadline );
            }
        }
    };
    bramidan.countrydetector = {
        init: function () {
            if ( jQuery( '#bramidan-country-detector' ).length === 1 ) {
                jQuery( '#bramidan-country-detector' ).modal();
            }
        }
    };
    bramidan.video = {
        init: function () {
            bramidan.video.bindEvents();
        },
        bindEvents: function () {
            jQuery( '.js-native-video-poster' ).on( 'click', function ( event ) {
                event.preventDefault();
                bramidan.video.show( this );
            } );
        },
        show: function ( domElm ) {
            //Show video based on type
            var poster = jQuery( domElm ),
                embed = jQuery( domElm ).parent().find( '.js-native-video-embed' );
            embed.hide().prop( 'hidden', false ).height( poster.height() ).find( 'video, iframe' ).height( poster.height() );

            poster.fadeOut( 'fast', function () {
                if ( poster.data( 'provider' ) === 'native' ) {
                    embed.fadeIn( 'fast' ).find( 'video' )[ 0 ].play();
                }
                else {
                    var src = embed.find( 'iframe' ).attr( 'src' );
                    embed.fadeIn( 'fast' ).find( 'iframe' ).attr( 'src', src + '&autoplay=true' );
                }

            } );
        }
    };
    bramidan.carousel = {
        init: function () {
            //var resizeTimer;
            bramidan.carousel.imageReplace();
            jQuery(window).on('resize', function(e) {
                bramidan.carousel.imageReplace();
            });
            bramidan.carousel.hasCaption();
            bramidan.carousel.video();
        },
        imageReplace: function () {
            //clearTimeout(resizeTimer);
            //resizeTimer = setTimeout(function() {
            var intWindowInnerWidth = window.innerWidth;
            jQuery( '.js-carousel-alt-img-replace' ).each( function () {
                var src = jQuery( this ).find( '.js-carousel-alt-img' ).attr( 'src' );
                if (intWindowInnerWidth < 992) {
                    jQuery( this ).css( 'background-image', 'url(' + src + ')' );
                } else {
                    if ( jQuery( this ).attr('data-hasvideo') === 'true' ) {
                        jQuery( this ).css({
                            'background-color': '#fff',
                            'background-image': 'none'
                        });
                    } else {
                        jQuery( this ).css( 'background-image', 'url(' + src + ')' );
                    }
                }
                //jQuery( this ).find( '.js-carousel-alt-img' ).remove();
            } );
            //}, 10);
        },
        hasCaption: function () {
            jQuery( '.bramidan-carousel' ).each( function () {
                if ( jQuery( this ).find( '.carousel-caption' ).length === 0 ) {
                    jQuery( this ).addClass( 'no-caption' );
                }
            } );
        },
        video: function () {
            //Video in carousel
            jQuery( '.js-bramidan-carousel-video-modal-trigger' ).on( 'click', function ( event ) {
                event.preventDefault();
                var videoFile = jQuery( this ).attr( 'href' );
                jQuery( '.js-bramidan-carousel-video-modal' ).find( 'video > source' ).attr( 'src', videoFile );
                if ( jQuery( '.js-bramidan-carousel-video-modal' ).find( 'video' ).length ) {
                    jQuery( '.js-bramidan-carousel-video-modal' ).find( 'video' )[ 0 ].load();
                }

                jQuery( '.js-bramidan-carousel-video-modal' ).on( 'show.bs.modal', function () {
                    if ( jQuery( '.js-bramidan-carousel-video' ).find( 'video' ).length ) {
                        jQuery( '.js-bramidan-carousel-video' ).find( 'video' )[ 0 ].pause();
                    }

                } ).on( 'hide.bs.modal', function () {
                    if ( jQuery( '.js-bramidan-carousel-video-modal' ).find( 'video' ).length ) {
                        jQuery( '.js-bramidan-carousel-video-modal' ).find( 'video' )[ 0 ].pause();
                    }

                    jQuery( '.js-bramidan-carousel-video-modal' ).find( 'source' ).attr( 'src', '' );
                    if ( jQuery( '.js-bramidan-carousel-video' ).find( 'video' ).length ) {
                        jQuery( '.js-bramidan-carousel-video' ).find( 'video' )[ 0 ].play();
                    }

                } ).modal();
            } );
        }
    };
    bramidan.modal = {
        init: function () {
            bramidan.modal.paragraphModal();
            bramidan.modal.cadModal();
        },
        paragraphModal: function () {
            if ( jQuery( 'a[target="modal"]' ).length > 0 ) {
                jQuery( 'a[target="modal"]' ).each( function () {
                    var modalLink = jQuery( this ),
                        modalHrefArr = modalLink.attr( 'href' ).split( '#' ),
                        modalID = 'bramidan-paragraph-modal-' + modalHrefArr[ ( modalHrefArr.length - 1 ) ];
                    modalLink.attr( {
                        href: '#' + modalID,
                        target: modalID
                    } );
                } ).on( 'click', function ( event ) {
                    event.preventDefault();
                    if ( jQuery( '.js-bramidan-paragraph-modal[id="' + jQuery( this ).attr( 'target' ) + '"]' ).length === 1 ) {
                        jQuery( '.js-bramidan-paragraph-modal[id="' + jQuery( this ).attr( 'target' ) + '"]' ).modal();
                    }
                } );
            }
        },
        cadModal: function () {
            jQuery( '.js-bramidan-ecom-product-specs-container' ).on( 'click', '.js-bramidan-ecom-product-specs-cad-modal-trigger', function ( event ) {
                event.preventDefault();
                var modal = jQuery( '#js-e-product-cad-modal' ),
                    src = jQuery( this ).attr( 'src' );
                modal.find( 'img' ).attr( 'src', src );
                modal.modal();

            } );
        }
    };
    bramidan.dealersearch = {
        options: {
            url: '/system/data/dealersearch',
            lang: navigator.language
        },
        init: function () {
            if ( jQuery( '#js-e-dealersearch-container' ).length === 1 ) {
                e4.util.require.js( e4.settings.require.handlebars, function () {
                    e4.handlebars.registerHelpers( 'compare' );
                    e4.handlebars.registerTemplates( '#js-e-handlebars-tmpl-bramidan-dealersearch' );
                    bramidan.dealersearch.bindEvents();
                    bramidan.dealersearch.get( bramidan.dealersearch.build );
                } );
            }
        },
        bindEvents: function () {
            jQuery( '#js-e-dealersearch-container' ).on( 'change', '.js-bramidan-country-selector', function () {
                var optionValue = jQuery( this ).val(),
                    optionGroup = jQuery( this.options[ this.selectedIndex ] ).closest( 'optgroup' ).data( 'type' );

                jQuery( '.js-bramidan-country' ).hide();
                jQuery( '.js-bramidan-continent' ).show();
                if ( optionGroup === 'country' ) {
                    jQuery( '.js-bramidan-country[data-contry-code="' + optionValue + '"]' ).fadeIn( 'slow' );
                    jQuery( '.js-bramidan-continent' ).each( function () {
                        var jRegion = jQuery( this );
                        if ( jRegion.children( '.js-bramidan-country:visible' ).length === 0 ) {
                            jRegion.hide();
                        }
                        else {
                            jRegion.show();
                        }
                    } );
                }
                else if ( optionGroup === 'continent' ) {
                    jQuery( '.js-bramidan-continent' ).each( function () {
                        var jRegion = jQuery( this );
                        if ( jRegion.data( 'continent' ) === optionValue ) {
                            jRegion.find( '.js-bramidan-country' ).show();
                            jRegion.fadeIn( 'slow' );
                        }
                        else {
                            jRegion.hide();
                        }
                    } );
                }
                else {
                    jQuery( '.js-bramidan-country' ).show();
                    jQuery( '.js-bramidan-continent' ).fadeIn( 'slow' );
                }

            } );
        },
        get: function ( callback ) {
            jQuery.ajax( {
                    url: bramidan.dealersearch.options.url,
                    type: 'GET',
                    dataType: 'json'
                } )
                .done( function ( data ) {
                    if ( callback ) {
                        callback( data );
                    }

                } )
                .fail( function ( error ) {
                    console.error( error );
                } );

        },
        build: function ( data ) {
            var jContainer = jQuery( '#js-e-dealersearch-container' ),
                bcc = jContainer.data( 'bcc-mails' ),
                caFound = false;
            for ( var i = 0; i < data.continents.length; i++ ) {
                if ( data.continents[ i ].continent === 'Canada' && caFound === false ) {
                    var itemToReplace = data.continents.splice( i, 1 );
                    data.continents = data.continents.concat( itemToReplace );
                    caFound = true;
                }

            }
            jQuery.each( data.selectList, function ( index, country ) {
                if ( country.value === jContainer.data( 'default-country' ) ) {
                    country.isSelected = true;
                    country.emailraw = jQuery.trim( country.email ) + bcc;
                }
            } );
            jQuery.each( data.dealers, function ( index, dealer ) {
                dealer.emailraw = jQuery.trim( dealer.email.value ) + '?bcc=' + bcc;
            } );
            jContainer.html( e4.handlebars.tmpl.bramidanDealersearch( data ) );
            jContainer.find( '.js-bramidan-country-selector' ).trigger( 'change' );

        }
    };
    bramidan.ecom = {
        details: {
            data: window.bramidanPineData,
            tmpl: [],
            init: function () {
                bramidan.ecom.details.customOptionExtras();
                bramidan.ecom.details.contactForm();
                jQuery( '.js-e-handlebars-tmpl-bramidan-ecom-product-template' ).each( function () {
                    bramidan.ecom.details.tmpl.push( '#' + jQuery( this ).attr( 'id' ) );
                } );
                if ( jQuery( '.js-bramidan-custom-ecom-top' ).length === 1 ) {
                    bramidan.ecom.details.carousel.init();
                }
                if ( jQuery( '.js-bramidan-ecom-product-details-container' ).length === 1 ) {
                    e4.util.require.js( e4.settings.require.handlebars, function () {
                        bramidan.ecom.details.registerHelpers();
                        e4.handlebars.registerHelpers( 'compare' );
                        e4.handlebars.registerTemplates( bramidan.ecom.details.tmpl.join( ' ' ) );
                        bramidan.ecom.details.build.productData();
                        bramidan.ecom.details.carousel.init();

                    } );
                }
                if ( jQuery( '.js-bramidan-contact-with-dynamic-countries' ).length > 0 ) {
                    bramidan.dealersearch.get( bramidan.ecom.details.build.contactSelect );
                }
            },
            customOptionExtras: function () {
                jQuery( '.js-custom-collapsable-optional-extras' ).each( function () {
                    var initialHeighht = jQuery( this ).outerHeight(),
                        firstOptionElement = jQuery( this ).find( '.js-custom-collapsable-optional-extras-item' ).first(),
                        height = firstOptionElement.outerHeight();
                    if ( jQuery( this ).find( '.js-custom-collapsable-optional-extras-item' ).length > 2 ) {

                        jQuery( this ).css( {
                            'height': height + 141,
                            'overflow': 'hidden',
                            'margin-bottom': '1em'
                        } ).attr( 'data-collapsed-height', height + 141 ).addClass( 'collapsed' ).after( '<a class="custom-collapsable-optional-extras-toggle js-custom-collapsable-optional-extras-toggle collapsed" href>' + jQuery( this ).data( 'open' ) + '</a>' );
                    }
                } );
                jQuery( document ).on( 'click', '.js-custom-collapsable-optional-extras-toggle', function ( event ) {
                    event.preventDefault();
                    var toToggle = jQuery( this ).prev( '.js-custom-collapsable-optional-extras' );
                    if ( toToggle.is( '.collapsed' ) === true ) {
                        toToggle.css( 'height', 'auto' );
                        jQuery( this ).text( toToggle.data( 'close' ) );
                    }
                    else {
                        toToggle.css( 'height', toToggle.data( 'collapsed-height' ) );
                        jQuery( this ).text( toToggle.data( 'open' ) );
                    }
                    jQuery( this ).toggleClass( 'collapsed' );
                    toToggle.toggleClass( 'collapsed' );

                } );
            },
            registerHelpers: function () {
                Handlebars.registerHelper( 'ifPineValue', function ( arr, value, options ) {
                    var returnValue = false;
                    for ( var i = 0; i < arr.length; i++ ) {
                        if ( arr[ i ].id === value ) {
                            returnValue = true;
                            options.data.root.fieldValue = arr[ i ].value;
                            break;
                        }
                    }
                    return returnValue === true ? new Handlebars.SafeString( options.fn( this ) ) : new Handlebars.SafeString( options.inverse( this ) );
                } );
                Handlebars.registerHelper( 'getPineValue', function ( arr, value, options ) {
                    var returnValue = {};
                    for ( var i = 0; i < arr.length; i++ ) {
                        if ( arr[ i ].id === value ) {
                            returnValue = arr[ i ];
                            break;
                        }
                    }
                    return returnValue.value !== undefined ? new Handlebars.SafeString( returnValue.value ) : returnValue.value;
                } );
            },
            getPdf: function () {
                jQuery( document ).on( 'click', '.js-generate-pdf', function ( event ) {

                    if ( jQuery( this ).attr( 'href' ) === 'false' ) {
                        event.preventDefault();

                        var pid = jQuery( this ).data( 'pid' ),
                            mpid = jQuery( this ).data( 'mpid' );
                        jQuery.ajax( {
                                url: '/services/getpdf.ashx?pid=569927&mpid=569927',
                                type: 'POST',
                                data: {
                                    pid: pid,
                                    mpid: mpid
                                }
                            } )
                            .done( function () {
                                //console.log( data );
                            } )
                            .fail( function ( error ) {
                                console.error( error );
                            } );
                    }

                } );
            },
            carousel: {
                clicks: 0,
                init: function () {
                    bramidan.ecom.details.carousel.bindEvents();
                },
                bindEvents: function () {
                    if ( jQuery( '#js-e-product-image-carousel' ).length ) {
                        jQuery.getScript( 'Files/Templates/Designs/espresso-v4/_assets/js/vendor/scroller.js', function () {

                            jQuery( '#js-e-product-image-carousel' ).find( 'ol' ).mThumbnailScroller( {
                                axis: 'y',
                                setHeight: jQuery( '#js-e-product-image-carousel' ).outerHeight(),
                                type: 'click-thumb',
                                markup: {
                                    buttonsHTML: {
                                        up: '<i class="material-icons">expand_less</i>',
                                        down: '<i class="material-icons">expand_more</i>',
                                    }
                                }
                            } );

                        } );
                    }

                }
            },
            contactForm: function () {
                if ( jQuery( '.js-product-form-modal-container' ).length ) {
                    var jHtml = jQuery( '.js-product-form-modal-container' ).html();
                    if ( jQuery( '.js-e-product-form-modal' ).length ) {
                        jQuery( '.js-e-product-form-modal' ).find( '.js-product-form-modal-target' ).html( jHtml );
                        setTimeout( function () {
                            e4.forms.validate.init();
                        }, 1000 );
                    }
                }
            },
            build: {
                contactSelect: function ( data ) {
                    var selectList = data.selectList;
                    jQuery( '.js-bramidan-contact-with-dynamic-countries' ).find( '.js-bramidan-dynamic-countries-select' ).append( '<option selected disabled>' + bramidanProductDetailsTranslations.chooseCountry + '</option>' );
                    for ( var i = 0; i < selectList.length; i++ ) {
                        var selectListItem = '<option value="' + selectList[ i ].value + '">' + selectList[ i ].label + '</option>';
                        jQuery( '.js-bramidan-contact-with-dynamic-countries' ).find( '.js-bramidan-dynamic-countries-select' ).append( selectListItem );
                    }
                    if ( jQuery( '.js-bramidan-got-questions' ).length > 0 ) {
                        var hash = jQuery( '.js-bramidan-contact-with-dynamic-countries' ).attr( 'id' );
                        jQuery( '.js-bramidan-got-questions' ).find( 'a' ).attr( 'href', location.href + '#' + hash );
                    }

                },
                productData: function () {
                    jQuery( '.js-bramidan-handlebars-build-container' ).each( function () {
                        var template = jQuery( this ).data( 'template' );
                        jQuery( this ).html( e4.handlebars.tmpl[ template ]( bramidan.ecom.details.data ) );
                    } );
                    bramidan.ecom.details.build.adjustments();

                },
                adjustments: function () {
                    var specCount = jQuery( '.bramidan-specs-collapse' ).find( 'tr' ).length,
                        iconCount = jQuery( '.js-bramidan-custom-info-wrapper-row' ).find( '.js-bramidan-custom-info-wrapper' ).length,
                        optionCount = jQuery( '.js-bramidan-options-collapse' ).find( '.js-bramidan-options-item' ).length;
                    if ( specCount > 11 ) {
                        jQuery( '.js-bramidan-specs-collapse-button-container' ).removeAttr( 'hidden' );
                    }
                    else {
                        jQuery( '.js-bramidan-specs-collapse, .js-bramidan-cad-container' ).addClass( 'auto-height' );
                    }
                    if ( ( bramidan.utils.isMobile() === false && optionCount > 3 ) || ( bramidan.utils.isMobile() === true && optionCount > 1 ) ) {
                        jQuery( '.js-bramidan-options-collapse-button-container' ).removeAttr( 'hidden' );
                    }
                    else if ( optionCount === 2 ) {
                        jQuery( '.js-bramidan-options-collapse' ).find( '.js-bramidan-options-item' ).each( function () {
                            jQuery( this ).removeClass( 'col-md-4' ).addClass( 'col-md-6' );
                        } );
                    }
                    else if ( optionCount === 0 ) {
                        jQuery( '.js-bramidan-ecom-product-optional-container' ).hide();
                        jQuery( '.js-bramidan-options-collapse' ).addClass( 'auto-height' );
                    }

                    if ( iconCount === 2 ) {
                        jQuery( '.js-bramidan-custom-info-wrapper-row' ).find( '.js-bramidan-custom-info-wrapper' ).each( function () {
                            jQuery( this ).removeClass( 'col-md-4' ).addClass( 'col-md-6' );
                        } );
                    }
                    else if ( iconCount === 4 ) {
                        jQuery( '.js-bramidan-custom-info-wrapper-row' ).find( '.js-bramidan-custom-info-wrapper' ).each( function () {
                            jQuery( this ).removeClass( 'col-md-4' ).addClass( 'col-md-3' );
                        } );
                    }
                    setTimeout( function () {
                        var height = jQuery( '.js-bramidan-options-collapse' ).find( '.js-bramidan-options-item' ).first().outerHeight();
                        jQuery( '.js-bramidan-options-collapse' ).find( '.js-bramidan-options-item' ).each( function ( index, el ) {
                            if ( jQuery( this ).outerHeight() > height ) {
                                height = jQuery( this ).outerHeight();
                            }
                        } );
                        jQuery( '.js-bramidan-options-collapse' ).css( {
                            'min-height': height,
                            'height': height
                        } );
                    }, 500 );
                    jQuery( window ).trigger( 'scroll' );

                }
            }
        }
    };
}() );

